import { render, staticRenderFns } from "./log.vue?vue&type=template&id=3669ac54&scoped=true"
import script from "./log.vue?vue&type=script&lang=ts"
export * from "./log.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3669ac54",
  null
  
)

export default component.exports